import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { Translate } from '@hydra/common/components';
import { Criterium, CriteriumSkeleton, CriteriumSchemaOrgTable, CriteriumKeywordsCloud } from '@hydra/common/criterium';
import { useReviewContext, usePdfTemplateContext } from '@hydra/common/context';

import { getContrastedColor, getPriSecColors } from '@hydra/utils/colors';

export const SchemaOrg = ({ criterium }) => {
  const { isPdf, variant } = useReviewContext();
  const { templateColors } = usePdfTemplateContext();
  const { primary } = isPdf
    ? templateColors
    : getPriSecColors();

  const color = getContrastedColor(primary);
  const { data } = criterium;

  const { items = [], issues = [], counts = {} } = data;

  const keywords = Object.keys(counts).map(keyword => ({
    keyword,
    url: `https://schema.org/${keyword}`,
    amount: counts[keyword]
  }));

  const content = (
    <>
      {
        isEmpty(counts) && isEmpty(issues)
          ? (variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <Translate content='schema_org_ko' />)
          : (
            <>
              {!isEmpty(counts) && <CriteriumKeywordsCloud keywords={keywords} color={color} />}
              {issues.length > 0 && <CriteriumSchemaOrgTable items={items} issues={issues} isPdf={isPdf} />}
            </>
            )
      }
    </>
  );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

SchemaOrg.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.object
      ),
      issues: PropTypes.arrayOf(
        PropTypes.object
      )
    })
  })
};

export default React.memo(SchemaOrg);
